import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ReportsService, ReportsDashboardViewModel, ReportsDashboardWidgetViewModel } from '../@apiClient/core';
import { environment } from '../../environments/environment';
import { I18NextPipe } from 'angular-i18next';


@Injectable()
export class DashboardDataService {

  @Output() onfetch: EventEmitter <Array<ReportsDashboardViewModel>> = new EventEmitter();
  
  
  private dashboards: Array<ReportsDashboardViewModel> = [];

  //  = [
  //   new 
  //   demo: {
  //     rows: [
  //       {
  //         widgets: [
  //           {
  //             type: 'value',
  //             title: 'Wartość umów',
  //             value: '214 tys EUR',
  //             label2: 'stan na 1 czerwca 2018',
  //             style: {
  //               class: 'gold'
  //             },
  //             colSize: 1
  //           },
  //           {
  //             type: 'chart-line',
  //             title: 'Wartość umów',
  //             valuesName: 'test',
  //             colSize: 1
  //           },
  //           {
  //             type: 'chart-pie',
  //             title: 'Wykonanie planu',
  //             value: 65,
  //             label: 'OK',
  //             label2: 'ponad założony plan',
  //             colSize: 1
  //           },
  //           {
  //             type: 'chart-pie',
  //             title: 'Bilans umów',
  //             value: 82,
  //             label: 'Podpisane',
  //             label2: 'względem potencjalnych',
  //             colSize: 1
  //           }
  //         ],
  //       },
  //       {
  //         widgets: [
  //           {
  //             type: 'list',
  //             colSize: 1
  //           },
  //           {
  //             type: 'list-chart-bars',
  //             colSize: 3
  //           },
  //         ]
  //       }
  //     ]
  //   },
  //   calendar: {
  //     rows: [
  //       [
  //         {
  //           type: 'tasks',
  //         },
  //         {
  //           type: 'activities',
  //         }
  //       ],
  //       [
  //         {
  //           type: 'tasks-calendar',
  //         },
  //       ]
  //     ]
  //   },
  //   report: {
  //     rows: [
  //       [
  //         {
  //           type: 'card-flip',
  //           cards: [
  //             {
  //               title: 'InfoBox1 A'
  //             },
  //             {
  //               title: 'InfoBox1 B'
  //             }
  //           ],
  //           style: {
  //             class: 'green'
  //           }
  //         },
  //         {
  //           type: 'card-flip',
  //           cards: [
  //             {
  //               title: 'InfoBox2 A'
  //             },
  //             {
  //               title: 'InfoBox2 B'
  //             }
  //           ],
  //           style: {
  //             class: 'red'
  //           }
  //         },
  //         {
  //           type: 'card-flip',
  //           cards: [
  //             {
  //               title: 'InfoBox3 A'
  //             },
  //             {
  //               title: 'InfoBox3 B'
  //             }
  //           ],
  //           style: {
  //             class: 'blue'
  //           }
  //         },
  //         {
  //           type: 'card-flip',
  //           cards: [
  //             {
  //               title: 'InfoBox4 A'
  //             },
  //             {
  //               title: 'InfoBox4 B'
  //             }
  //           ],
  //           style: {
  //             class: 'gold'
  //           }
  //         }
  //       ],
  //       [
  //         { type: 'report' }
  //       ]
  //     ]
  //   }
  // };

  // private dashboard_calendar = new BehaviorSubject<any>(this.dashboard_data.calendar);
  // private dashboard_reportKlip = new BehaviorSubject<any>(this.dashboard_data.reportKlip);
  // private dashboard_reportGrid = new BehaviorSubject<any>(this.dashboard_data.reportGrid);

  // private dashboard_calendar_widgets = new BehaviorSubject<any>(this.dashboard_widgets.calendar);
  // private dashboard_report_widgets = new BehaviorSubject<any>(this.dashboard_widgets.report);

  // calendar_data = this.dashboard_calendar.asObservable();
  // reportKlip_data = this.dashboard_reportKlip.asObservable();
  // reportGrid_data = this.dashboard_reportGrid.asObservable();

  // calendar_widgets = this.dashboard_calendar_widgets.asObservable();
  // report_widgets = this.dashboard_report_widgets.asObservable();

  constructor(private reportService: ReportsService,
    private i18NextPipe: I18NextPipe) { 
    !environment.production && environment.showDemo && this.loadDemo();
  }

  getDashboard(dashboardName: string): void {
    var dashboard = this.dashboards.find( d => d.shortName == dashboardName);
    if (!!dashboard){
      this.onfetch.emit([dashboard]);
    }
    else {
      this.fetchDashboard(dashboardName);
    }
  }
  getDashboards(){
    this.fetchDashboards();
  }
  private fetchDashboards():void{
    this.reportService.getDashboards(false).subscribe( results => {
      let dashboards = results.data;
      this.dashboards = [];
      this.dashboards.push(...dashboards);
      !environment.production && environment.showDemo && this.loadDemo();
      this.onfetch.emit(this.dashboards);
    });
  }
  private fetchDashboard(dashboardName: string):void{
    this.reportService.getDashboard(dashboardName, false).subscribe( results => {
      let dashboard = results.data;
      !!dashboard && this.onfetch.emit([dashboard]);
    });
  }

  loadDemo(){
    this.dashboards.push(<ReportsDashboardViewModel>{
      name:"Demo",
      shortName:"demo",
      widgets: [<ReportsDashboardWidgetViewModel>{
        positionRow: 1,
        positionCol: 1,
        sizeCol: 1,
        sizeRow: 1,
        title: this.i18NextPipe.transform('Contracts value'),
        widgetKind: 1,
        widgetSeriesCount:1,
        data: [{
          value: '214 tys EUR',
          label2: 'stan na 1 czerwca 2018',
          style: { class: 'gold'}}],
        dataColumns: []
      }, <ReportsDashboardWidgetViewModel>{
        positionRow: 1,
        positionCol: 2,
        sizeCol: 1,
        sizeRow: 1,
        title: this.i18NextPipe.transform('Contracts value'),
        widgetKind: 3,
        widgetSeriesCount:3,
        data: [
          { series: 'week', values: [300, 520, 435, 530, 730, 620, 660, 860] },
          { series: 'month', values: [300, 520, 435, 530, 730, 620, 660, 860] },
          { series: 'year', values: [500, 520, 235, 530, 730, 620, 660, 860] },
        ],
        dataColumns: []
      }, <ReportsDashboardWidgetViewModel>{
        positionRow: 1,
        positionCol: 3,
        sizeCol: 1,
        sizeRow: 1,
        title: this.i18NextPipe.transform('Execution of the plan'),
        widgetKind: 2,
        widgetSeriesCount:3,
        data: [{ 
          value: 65, label: 'OK',  label2: this.i18NextPipe.transform('above the assumed plan')}],
        dataColumns: []
      }, <ReportsDashboardWidgetViewModel>{
        positionRow: 1,
        positionCol: 4,
        sizeCol: 1,
        sizeRow: 1,
        title: this.i18NextPipe.transform('Contract balance'),
        widgetKind: 2,
        widgetSeriesCount:3,
        data: [{ 
          value: 82, label: this.i18NextPipe.transform('Signed'),  label2: this.i18NextPipe.transform('relative to potential')}],
        dataColumns: []
      }, <ReportsDashboardWidgetViewModel>{
        positionRow: 2,
        positionCol: 1,
        sizeCol: 1,
        sizeRow: 3,
        title: '',
        widgetKind: 7,
        widgetSeriesCount:3,
        data: [],
        dataColumns: []
      }, <ReportsDashboardWidgetViewModel>{
        positionRow: 2,
        positionCol: 1,
        sizeCol: 3,
        sizeRow: 3,
        title: '',
        widgetKind: 6,
        widgetSeriesCount:3,
        data: [],
        dataColumns: []
      }]
    });
  }

}
